import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import "./workout-gallery.css";
import img1 from "../images/img5.jpeg";
import img2 from "../images/img2.jpeg";
import img3 from "../images/img3.jpeg";
import img4 from "../images/img4.jpeg";
import img5 from "../images/img6.jpeg";
import img6 from "../images/img7.jpeg";
import img7 from "../images/homeImage.png";
import img8 from "../images/img8.jpg";

const images = [img1, img2, img3, img4, img5, img6, img7, img8];

export default function WorkoutGallery() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const handlePrev = () => {
    setSelectedImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleClose = () => setSelectedImageIndex(null);

  const handleKeyDown = (event) => {
    if (selectedImageIndex !== null) {
      if (event.key === "ArrowLeft") handlePrev();
      else if (event.key === "ArrowRight") handleNext();
      else if (event.key === "Escape") handleClose();
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  });

  return (
    <section className="gallery-section-wrapper">
      <div className="gallery-outer">
        <div className="gallery-header">
          <div className="gallery-eyebrow">Pogledaj</div>
          <h2 className="gallery-title">GALERIJA</h2>
        </div>

        <div className="gallery-container">
          {images.map((src, index) => (
            <div
              className="gallery-item"
              key={index}
              onClick={() => setSelectedImageIndex(index)}
            >
              <img src={src} alt="Slike galerije" />
            </div>
          ))}
        </div>

        {selectedImageIndex !== null && (
          <div className="modal">
            <button className="close" onClick={handleClose} aria-label="Zatvori galeriju">
              <X size={32} strokeWidth={2.2} />
            </button>
            <img
              className="modal-content"
              src={images[selectedImageIndex]}
              alt="Selected"
            />
            <button className="prev" onClick={handlePrev} aria-label="Prethodna slika">
              <ChevronLeft size={34} strokeWidth={2.2} />
            </button>
            <button className="next" onClick={handleNext} aria-label="Sledeća slika">
              <ChevronRight size={34} strokeWidth={2.2} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
